import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=25580eba&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports